<template>
    <div class="d-inline-block">
        <button type="button" :class="[value ? 'btn btn-outline-success' : 'btn btn-outline-primary']" @click="show = true">
            <template v-if="value">
                <i class="tlm-icon-spiral mr-2" /> Конвертация включена
            </template>

            <template v-else>
                <i class="tlm-icon-info-circle mr-2" /> Исправить нумерацию
            </template>
        </button>

        <TheModal v-if="show" class="sm" @close="close">
            <template v-slot:head>Нумерация продуктов</template>

            <p>Автомат присылает неправильные номера продуктов?<br>Выберите вашу модель из списка.</p>

            <ValidationObserver ref="editFormMobile" v-slot="{ invalid }" tag="form" class="form-thin my-2" @submit.prevent="submit">
                <ValidationProvider v-errors tag="div" class="form-group mb-3" vid="max" rules="integer|min_value:1">
                    <select-bus-numbering-scheme v-model="localValue" @select="selected" />
                    <small v-show="description" class="text-muted">{{ description }}</small>
                </ValidationProvider>

                <p v-if="showTip" class="mb-4">Новые продажи придут с правильными номерами.</p>

                <button type="submit" :disabled="invalid" class="btn btn-primary btn-lg-192">Сохранить</button>
            </ValidationObserver>
        </TheModal>
    </div>
</template>

<script>
import TheModal from '@/components/TheModal'
import SelectBusNumberingScheme from '@/components/SelectBusNumberingScheme'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
    components: {
        TheModal,
        SelectBusNumberingScheme,
        ValidationObserver,
        ValidationProvider
    },

    props: {
        value: {
            type: String | Number,
            default: null
        }
    },

    data() {
        return {
            localValue: this.value,
            show: false,
            description: ''
        }
    },

    computed: {
        showTip() {
            return this.value !== this.localValue
        }
    },

    watch: {
        value(value) {
            this.localValue = value
        }
    },

    methods: {
        submit() {
            this.$emit('input', this.localValue)
        },

        selected(scheme) {
            this.description = ''

            if (scheme.description) {
                this.description = scheme.description
            }
        },

        close() {
            this.show = false
            this.localValue = this.value
        }
    }
}
</script>
